// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2fcf14a9","703":"f09d5d99","787":"7b377125"}[chunkId] + ".chunk.js";
};